import { useNavigate, useSearchParams } from "react-router-dom";
import { Subtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { onboardingPath } from "../../core/primitives/onboarding";
import { OnboardingLocationsController } from "./onboarding-locations-controller";
import { OnboardingLocationsPage } from "./onboarding-locations-page";

export function OnboardingLocationsRoute({ deps }: { deps: AppDeps }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const claimOnboarding = searchParams.get("claimOnboarding") === "1";
  const storeIdParam = searchParams.get("storeId");
  return (
    <Subtree
      key="onboarding-locations"
      deps={[claimOnboarding, storeIdParam]}
      controller={() =>
        new OnboardingLocationsController(
          pick(deps, "client", "authHandler", "storeRepository", "locationsRepository", "countriesRepository"),
          { claimOnboarding, storeIdParam },
          {
            toPrevious: (storeId, claim) =>
              navigate(claim ? onboardingPath("shop", storeId, true) : onboardingPath("selling", storeId)),
            toWebsite: (storeId, claim) => navigate(onboardingPath("website", storeId, claim)),
          },
        )
      }
    >
      <OnboardingLocationsPage />
    </Subtree>
  );
}
